import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo, ReactNode } from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const PreInspectionReportSection: FC<{
  title?: ReactNode;
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
}> = memo(({ title, children, style, contentStyle }) => {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        background-color: ${theme.section.background};
        margin-bottom: ${rpx(15)}px;
      `}
      style={style}
    >
      {typeof title === 'string' ? (
        <Text
          css={`
            align-self: center;
            margin: ${rpx(10)}px;
            font-family: ${FontFamily.NotoSans.Medium};
            font-size: ${rpx(19)}px;
          `}
        >
          {title}
        </Text>
      ) : (
        title
      )}
      <View style={contentStyle}>{children}</View>
    </View>
  );
});
